import React from 'react';
import './headingElement.scss';

export const HeadingElement = () => {
    return (
        <div>
            <div className={'heading-element'}>
                <div className={'heading-element_lg-box'}/>
                <div className={'heading-element_sm-box'}/>
            </div>
        </div>
    );
};


